import PropTypes from "prop-types";
import React, { useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import MenuCart from "./sub-components/MenuCart";
import { removeFromCart } from "../../redux/actions/cartActions";
import { clearProducts } from "../../redux/actions/productsAction";
import MenuWishList from "./sub-components/MenuWishList";

const IconGroup = ({
  currency,
  cartData,
  wishlistData,
  compareData,
  removeFromCart,
  removeFromWishlist,
  productData,
  clearProducts,
  getSortParams,
  isUser,
  useFocusMobile,
  setInputFocusMobile,
}) => {
  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };
    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const history = useHistory();
  const handleClick = (e) => {
    const oldE =
      e.currentTarget.className === "icon-cart"
        ? document.getElementById("btnWishlist")
        : document.getElementById("btnCart");
    if (oldE && oldE.nextSibling.classList.contains("active"))
      oldE.nextSibling.classList.toggle("active");
    e.currentTarget.nextSibling.classList.toggle("active");
    setTimeout(() => {
      setInputFocus();
    }, 300);
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
    //console.log(setInputFocusMobile)
    //console.log(setInputFocus)
    setTimeout(() => {
      setInputFocusMobile();
    }, 300);
  };

  const search = () => {
    var queryText = document.getElementById("queryText").value;
    history.push("/redirect");
    setTimeout(
      () =>
        history.push(
          process.env.PUBLIC_URL + "/shop-grid-full-width?name=" + queryText
        ),
      10
    );
  };

  var totItems = 0;
  if (cartData && Array.isArray(cartData))
    cartData.map((item) => {
      totItems += parseInt(item.quantity);
    });
  return (
    <div
      className="header-right-wrap"
      style={{ padding: "0px", margin: "16px" }}
    >
      <div className="same-style header-search d-none d-lg-block">
        <button className="search-active" onClick={(e) => handleClick(e)}>
          <i className="pe-7s-search" />
        </button>
        <div className="search-content">
          <form
            className="pro-sidebar-search-form"
            style={{ height: "100%", width: "100%" }}
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <input
              ref={inputRef}
              type="text"
              autoFocus
              placeholder="Cerca..."
              id="queryText"
              onKeyDown={(e) => {
                if (e.key == "Enter") search();
              }}
            />
            <button
              type="button"
              className="button-search"
              onClick={() => search()}
            >
              <i className="pe-7s-search" />
            </button>
          </form>
        </div>
      </div>

      {isUser ? (
        <>
          {/*<div className="same-style header-compare">
          <Link to={process.env.PUBLIC_URL + "/compare"} style={{ pointerEvents: "none" }}>
            <i className="pe-7s-shuffle" />
            <span className="count-style">
              {compareData && compareData.length ? compareData.length : 0}
            </span>
          </Link>
      </div>*/}

          {/*        <div className="same-style header-wishlist">
          <Link to={process.env.PUBLIC_URL + "/wishlist"}>
            <i className="pe-7s-like" />
            <span className="count-style">
              {wishlistData && wishlistData.length ? wishlistData.length : 0}
            </span>
          </Link>
      </div>*/}

          <div className="same-style cart-wrap d-none d-lg-block">
            {global.aziendaID != 3 && <button
              id={"btnCart"}
              className="icon-cart"
              onClick={(e) => handleClick(e)}
            >
              <i className="pe-7s-like" />
              <span className="count-style">
                {wishlistData && wishlistData.length ? wishlistData.length : 0}
              </span>
            </button>}
            {/* menu cart */}
            <MenuWishList
              wishlistData={wishlistData}
              currency={currency}
              removeFromWishlist={removeFromWishlist}
            />
          </div>

          <div className="same-style cart-wrap d-none d-lg-block">
            <button
              id={"btnWishlist"}
              className="icon-wishList"
              onClick={(e) => handleClick(e)}
            >
              <i className="pe-7s-cart" />
              <span className="count-style">
                {cartData && cartData.length ? totItems : 0}
              </span>
            </button>
            {/* menu cart */}
            <MenuCart
              cartData={cartData}
              currency={currency}
              removeFromCart={removeFromCart}
            />
          </div>

          {global.aziendaID != 3 && (
            <div className="same-style cart-wrap d-block d-lg-none">
              <Link
                className="icon-wishList"
                to={process.env.PUBLIC_URL + "/wishlist"}
              >
                <i className="pe-7s-like" />
                <span className="count-style">
                  {wishlistData && wishlistData.length ? wishlistData.length : 0}
                </span>
              </Link>
            </div>)}

          <div className="same-style cart-wrap d-block d-lg-none">
            <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
              <i className="pe-7s-shopbag" />
              <span className="count-style">
                {cartData && cartData.length ? totItems : 0}
              </span>
            </Link>
          </div>

          <div className="same-style mobile-off-canvas d-block d-lg-none">
            <button
              className="mobile-aside-button"
              onClick={() => triggerMobileMenu()}
            >
              <i className="pe-7s-menu" />
            </button>
          </div>
        </>
      ) : null}

      {!isUser && (
        <>
          <div className="same-style cart-wrap d-block d-lg-none">
            <Link
              className="icon-wishList"
              to={process.env.PUBLIC_URL + "/login"}
            >
              <i className="pe-7s-user" />
            </Link>
          </div>
        </>
      )}
    </div>
  );
};

IconGroup.propTypes = {
  cartData: PropTypes.array,
  compareData: PropTypes.array,
  currency: PropTypes.object,
  removeFromCart: PropTypes.func,
  wishlistData: PropTypes.array,
  setToken: PropTypes.func,
  productsData: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    currency: state.currencyData,
    cartData: state.cartData,
    wishlistData: state.wishlistData,
    compareData: state.compareData,
    productData: state.productData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    removeFromCart: (item, addToast) => {
      dispatch(removeFromCart(item, addToast));
    },
    clearProducts: () => {
      dispatch(clearProducts());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IconGroup);
